export default __webpack_public_path__ + "2ca7255826d3a1eabed0acd5ee6ad137.svg";